<form *ngIf="employee" class="responsive-grid" #form="ngForm" autocomplete="off">
    <ui-banner class="columns-12 margin-bottom-3">
        <p class="w-100">
            {{
                'components.edit-employee-additional-income.canSetRecurringAmount'
                    | translate
                        : {
                              employeeFullName: employee.fullName,
                              caiDisplayName: companyAdditionalIncome.displayName,
                          }
            }}
        </p>
    </ui-banner>

    <mat-form-field class="columns-12">
        <mat-label>{{ 'components.edit-employee-additional-income.recurringAmount' | translate }}</mat-label>
        <input
            name="amount"
            matInput
            [(ngModel)]="employeeAdditionalIncome.amount"
            #amount="ngModel"
            type="number"
            min="0"
            required
        />
        <mat-error *ngIf="amount.invalid">{{ amount.errors | formErrors }}</mat-error>
    </mat-form-field>
</form>
